import { useState } from "react";
import Toast from "@/components/base/Toast";
import { discussionThreads } from "@/mocks/home";

export default function DiscussionBoard() {
  const [draft, setDraft] = useState("");
  const [toast, setToast] = useState<string | null>(null);

  const handlePost = () => {
    setToast(
      draft.trim()
        ? "演示模式：你的讨论不会真实发布"
        : "先写点想聊的内容再发布吧（演示模式）",
    );
    window.setTimeout(() => setToast(null), 2200);
  };

  return (
    <section id="discussion" className="w-full border-b border-background-200 bg-background-50">
      <div className="mx-auto w-full max-w-page px-4 py-8 md:px-6 md:py-12">
        <div className="mb-6 flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs text-accent-900">
              <i className="ri-chat-smile-3-line text-accent-700" />
              吃瓜讨论区
            </span>
            <h2 className="mt-3 font-heading text-3xl leading-tight text-foreground-950 md:text-4xl">
              社区正在热聊
            </h2>
            <p className="mt-2 max-w-2xl text-sm text-foreground-600 md:text-base">
              有人整理时间线，有人只想搬板凳。这里的讨论就事论事，欢迎补充细节与纠错。
            </p>
          </div>
          <span className="flex w-fit items-center gap-1.5 whitespace-nowrap rounded-full border border-background-300 bg-background-100 px-3 py-1.5 text-xs text-foreground-600">
            <i className="ri-user-voice-line text-secondary-600" />
            2,860 人正在浏览
          </span>
        </div>

        <div className="mb-6 flex flex-col gap-3 rounded-lg border border-background-200 bg-background-100 p-4 sm:flex-row sm:items-center md:p-5">
          <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary-500 font-heading text-lg text-background-50">
            我
          </span>
          <input
            type="text"
            value={draft}
            onChange={(event) => setDraft(event.target.value)}
            placeholder="说说你对今天头版的看法⋯⋯"
            className="w-full flex-1 rounded-md border border-background-300 bg-background-50 px-3.5 py-2.5 text-sm text-foreground-800 outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-300"
          />
          <button
            type="button"
            onClick={handlePost}
            className="inline-flex w-fit cursor-pointer items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-send-plane-2-line" />
            发布讨论
          </button>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {discussionThreads.map((thread) => (
            <article
              key={thread.title}
              className="flex cursor-pointer flex-col rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-accent-300 md:p-5"
            >
              <div className="flex items-center gap-2.5">
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-secondary-500 font-heading text-base text-background-50">
                  {thread.avatar}
                </span>
                <div className="min-w-0 leading-tight">
                  <p className="truncate text-sm text-foreground-900">{thread.name}</p>
                  <p className="truncate text-xs text-foreground-500">
                    {thread.role} · {thread.time}
                  </p>
                </div>
              </div>
              <h3 className="mt-3 line-clamp-2 font-heading text-base leading-snug text-foreground-950 md:text-lg">
                {thread.title}
              </h3>
              <p className="mt-1.5 line-clamp-2 text-sm leading-relaxed text-foreground-600">
                {thread.summary}
              </p>
              <div className="mt-3 flex flex-wrap gap-1.5">
                {thread.tags.map((tag) => (
                  <span
                    key={tag}
                    className="rounded-full bg-background-100 px-2.5 py-0.5 text-[11px] text-foreground-600"
                  >
                    #{tag}
                  </span>
                ))}
              </div>
              <div className="mt-4 flex items-center gap-4 border-t border-background-200 pt-3 text-xs text-foreground-500">
                <span className="flex items-center gap-1">
                  <i className="ri-chat-1-line" />
                  {thread.replies} 回复
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-thumb-up-line" />
                  {thread.likes}
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
      <Toast message={toast} />
    </section>
  );
}